import MenuDrawer from "./MenuDrawer";

export default class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
        this.setVar('loadPage')
    }

    setVar(when) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        this.usps = this.header.querySelector('.usp-bar');
        if (this.usps) {
            this.uspOffset = this.usps.offsetHeight;
        } else {
            this.uspOffset = 0;
        }

        let headerPosition = '0'; //todo: change to number if possible
        if (when == 'loadPage') {
            headerPosition = this.header.offsetHeight + this.uspOffset;
        } else {
            headerPosition = this.header.getBoundingClientRect().bottom;
        }
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerPosition - this.borderOffset - this.uspOffset)}px`);
    }


    openMenuDrawer(summaryElement) {
        this.setVar('openMenu');

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
}